module.exports = __webpack_public_path__ + "static/media/picture-(241).9df20242.JPG";